import { useIsInEmbedMode } from "../hooks";

export const HideInEmbedMode = ({ children }) => {
  const isInEmbedMode = useIsInEmbedMode();
  return isInEmbedMode ? null : children;
};
